module.exports = __webpack_public_path__ + "img/title3.8f4c333.png";